import Spinner from 'src/javascripts/components/utilities/Spinner'

export default class ExportsSchedulesEdit {

  constructor() {}

  render() {

    // Clear formatted name on select template from
    $('#template_id').bind("typeahead:select typeahead:autocomplete", function (ev, suggestion) {
      $(this).typeahead('val', '');
      $('.modal-body').css('opacity', '0.3');
      Spinner('.modal-content');
      const templateId = suggestion.record_id;
      const scheduleName = $('#exports_schedule_name').val();
      const startDate = $('#exports_schedule_start_date').val();
      const frequency = $('#exports_schedule_frequency').val();
      const emails = $('#exports_schedule_emails_storage').val();
      const url = new URL(window.location.href);
      url.searchParams.set('template_id', templateId);
      url.searchParams.set('schedule_name', scheduleName);
      url.searchParams.set('start_date', startDate);
      url.searchParams.set('frequency', frequency);
      url.searchParams.set('emails', emails);
      Turbo.visit(url.toString());
    });

  }

}
